import { useUserStore } from './modules/user'

// 当用户切换或者退出登录 TODO: 清除localStorage ?
export function resetStore() {
  const userStore = useUserStore()
  userStore.$reset()
}

export function getUserToken() {
  const userStore = useUserStore()
  return userStore.token
}

export function pushEventTags(...args: [string, string]) {
  const userStore = useUserStore()
  userStore.pushEventTags(...args)
}
